import { ModelBase } from 'store/model-base';

export class E911Address extends ModelBase {
    public static storeName: string = 'e911Address';

    public address1: string;
    public address2: string;
    public city: string;
    public state: string;
    public zip: string;
    public mdn: string;
    public address: E911AddressDetails;
    public isValid: boolean;
    public formatted: string;
    public cityStateZip: string;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.address1 = data?.address?.address1 ? data.address.address1 : data?.address1;
        data.address2 = data?.address?.address2 ? data.address.address2 : data?.address2;
        data.city = data?.address?.city ? data.address.city : data?.city;
        data.state = data?.address?.state ? data.address.state : data?.state;
        data.zip = data?.address?.zip ? data.address.zip : data?.zip;
        data.isValid = Boolean(data.address1 && data.address1.trim());
        data.formatted = `${data.address1} ${data.city}, ${data.state} ${data.zip}`;
        data.cityStateZip = `${data.city}, ${data.state} ${data.zip}`;

        const toReturn: E911Address = super.create<E911Address>(data);

        return super.create<T>(toReturn);
    }
}
